// Blooms The Chemist — MedFast Pharmacy Location
export const locations = [
  {
    id: 'LOC001',
    name: 'Blooms Melbourne Central',
    fullName: 'Blooms The Chemist Melbourne Central',
    address: '250 Collins St, Melbourne VIC 3000',
    phone: '(03) 9654 1200',
    fax: '(03) 9654 1201',
    email: 'melbournecentral@bloomsthechemist.com.au',
    approvalNumber: 'AP-2547H',
    abn: '14 895 623 107',
    type: 'metro',
    isMain: true,
    manager: 'Alex Pharmacist',
    operatingHours: {
      weekday: '8:00 AM - 8:00 PM',
      saturday: '8:30 AM - 5:00 PM',
      sunday: '10:00 AM - 4:00 PM',
    },
    deliveryDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    services: ['Dispensing', 'Vaccinations', 'Webster-pak', 'MedsCheck', 'Blood Pressure', 'NDIS'],
  },
];

// Stock transfer history
export const stockTransfers = [];
